export class NavigationBarAlertService {
  private isInAlertMode: boolean;
  constructor() {
    this.isInAlertMode = false;
  }

  putInAlertState(): void {
    this.isInAlertMode = true;
  }

  toggleStateTo(bool: boolean): void {
    this.isInAlertMode = !!bool;
  }

  reset(): void {
    this.isInAlertMode = false;
  }

  get alertStatus() {
    return this.isInAlertMode;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-navbar/src/app_nav_bar/services/navigation_bar_alert_service.ts